export const PRECACHE_NAME = 'did-web-precache';

export async function registerSW() {
	if ('serviceWorker' in navigator) {
		const reg = await navigator.serviceWorker
			.register('/sw.js', { scope: '/' })
			.catch(err =>
				console.error('Service worker registration failed:', err)
			);

		if (!reg) return;

		// Listen for when a new SW takes control
		navigator.serviceWorker.addEventListener('controllerchange', () => {
			const isIdle = sessionStorage.getItem('sspTrackingSessionId') === null;

			if (isIdle) {
				window.location.reload();
			} else {
				localStorage.setItem('pending-reload', 'true');
			}
		});
	}
}
